import i18n from './tick-unit.properties';

const TICK_UNIT_VALUES = [ 'years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds' ] as const;

const TICK_UNIT_ORDER: Record<TickUnit, number> = {
  'seconds': 0,
  'minutes': 1,
  'hours': 2,
  'days': 3,
  'weeks': 4,
  'months': 5,
  'years': 6
} as const;

const TICK_UNIT_TO_DATE_FORMAT_UNIT: Record<TickUnit, string> = {
  'seconds': 's',
  'minutes': 'm',
  'hours': 'H',
  'days': 'd',
  'weeks': 'w',
  'months': 'M',
  'years': 'y'
} as const;

/**
 * Possible units to specify steps in which to step through the temporal data. The values are
 * directly usable as keys for a date-fns {@link Duration}.
 *
 * Corresponding Java enum: net.disy.cadenza.workbook.resolving.condition.TickUnit
 * It is not generated, because we have quite some custom logic and extensions.
 */
export type TickUnit = typeof TICK_UNIT_VALUES[number];

export const TickUnit = {
  values: TICK_UNIT_VALUES as readonly TickUnit[],
  order: (unit: TickUnit) => TICK_UNIT_ORDER[unit],
  toDateFormatUnit: (unit: TickUnit) => TICK_UNIT_TO_DATE_FORMAT_UNIT[unit],
  i18n: (unit: TickUnit, { plural = false, shortFormat = false } = {}) =>
    shortFormat ? i18n(`shortTickUnit.${unit}`) : i18n(`tickUnit.${unit}.${plural ? 'plural' : 'singular'}`)
} as const;
